/**
 * Mock body stats data for development.
 * Shows gradual progress over 3 months: weight 195 -> 182, body fat 22% -> 18%.
 */
import { subDays } from 'date-fns';

const now = new Date();

export const MOCK_BODY_STATS = [
  {
    id: 'mock_bs_01',
    date: subDays(now, 90).toISOString(),
    weight: 195,
    bodyFatPercentage: 22,
    measurements: { chest: 42, waist: 36, hips: 40, arms: 14.5, thighs: 24 },
    notes: 'Starting point. Time to get serious.',
    createdAt: subDays(now, 90).toISOString(),
  },
  {
    id: 'mock_bs_02',
    date: subDays(now, 80).toISOString(),
    weight: 193,
    bodyFatPercentage: 21.5,
    measurements: { chest: 42, waist: 35.5, hips: 40, arms: 14.5, thighs: 24 },
    notes: 'First couple weeks down.',
    createdAt: subDays(now, 80).toISOString(),
  },
  {
    id: 'mock_bs_03',
    date: subDays(now, 70).toISOString(),
    weight: 191,
    bodyFatPercentage: 21,
    measurements: { chest: 42, waist: 35, hips: 39.5, arms: 14.5, thighs: 23.5 },
    notes: 'Consistency paying off.',
    createdAt: subDays(now, 70).toISOString(),
  },
  {
    id: 'mock_bs_04',
    date: subDays(now, 60).toISOString(),
    weight: 190,
    bodyFatPercentage: 20.5,
    measurements: { chest: null, waist: 34.5, hips: null, arms: null, thighs: null },
    notes: '',
    createdAt: subDays(now, 60).toISOString(),
  },
  {
    id: 'mock_bs_05',
    date: subDays(now, 50).toISOString(),
    weight: 188,
    bodyFatPercentage: 20,
    measurements: { chest: 41.5, waist: 34, hips: 39, arms: 14.5, thighs: 23.5 },
    notes: 'Waist is coming down nicely.',
    createdAt: subDays(now, 50).toISOString(),
  },
  {
    id: 'mock_bs_06',
    date: subDays(now, 42).toISOString(),
    weight: 187,
    bodyFatPercentage: 19.5,
    measurements: { chest: null, waist: 33.5, hips: null, arms: null, thighs: null },
    notes: '',
    createdAt: subDays(now, 42).toISOString(),
  },
  {
    id: 'mock_bs_07',
    date: subDays(now, 35).toISOString(),
    weight: 186,
    bodyFatPercentage: 19.5,
    measurements: { chest: 41, waist: 33.5, hips: 38.5, arms: 14.5, thighs: 23 },
    notes: 'Plateau but measurements still changing. Recomposition!',
    createdAt: subDays(now, 35).toISOString(),
  },
  {
    id: 'mock_bs_08',
    date: subDays(now, 28).toISOString(),
    weight: 185,
    bodyFatPercentage: 19,
    measurements: { chest: null, waist: 33, hips: null, arms: 15, thighs: null },
    notes: 'Arms growing - the cut is going well.',
    createdAt: subDays(now, 28).toISOString(),
  },
  {
    id: 'mock_bs_09',
    date: subDays(now, 21).toISOString(),
    weight: 184,
    bodyFatPercentage: 18.5,
    measurements: { chest: 41, waist: 32.5, hips: 38, arms: 15, thighs: 23 },
    notes: 'Under 185! Getting close to the goal.',
    createdAt: subDays(now, 21).toISOString(),
  },
  {
    id: 'mock_bs_10',
    date: subDays(now, 14).toISOString(),
    weight: 183,
    bodyFatPercentage: 18.5,
    measurements: { chest: null, waist: 32.5, hips: null, arms: null, thighs: null },
    notes: '',
    createdAt: subDays(now, 14).toISOString(),
  },
  {
    id: 'mock_bs_11',
    date: subDays(now, 7).toISOString(),
    weight: 182.5,
    bodyFatPercentage: 18,
    measurements: { chest: 41, waist: 32, hips: 38, arms: 15, thighs: 23 },
    notes: 'Almost at 18% BF. Looking lean.',
    createdAt: subDays(now, 7).toISOString(),
  },
  {
    id: 'mock_bs_12',
    date: subDays(now, 2).toISOString(),
    weight: 182,
    bodyFatPercentage: 18,
    measurements: { chest: 41, waist: 32, hips: 37.5, arms: 15.5, thighs: 23 },
    notes: 'Hit the goal! 13lbs down, 4% BF reduction.',
    createdAt: subDays(now, 2).toISOString(),
  },
];
